import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './resources/en.json';
import id from './resources/id.json';

enum LANGUAGE {
  ENGLISH = 'en',
  BAHASA = 'id',
}

// Manually get language from URL
const urlParams = new URLSearchParams(window.location.search);
const language = urlParams.get('language') || LANGUAGE.ENGLISH;

i18n.use(initReactI18next).init({
  resources: {
    [LANGUAGE.ENGLISH]: { translation: en },
    [LANGUAGE.BAHASA]: { translation: id },
  },
  lng: language,
  fallbackLng: LANGUAGE.ENGLISH,
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
